<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.opinion.newMadePublicByMember.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.opinion.newMadePublicByMember.p2')}}
    "<router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>"
    {{$t('news.template.opinion.newMadePublicByMember.p3')}}
    {{news.textParams[5]}}
    {{$t('news.template.opinion.newMadePublicByMember.p4')}}
    "<router-link :to="{name: 'OpinionView', params: {hash: news.textParams[3]}}">
      {{news.textParams[6]}}
    </router-link>"
    {{$t('news.template.opinion.newMadePublicByMember.p5')}}
  </div>
</template>
